module.exports = __webpack_public_path__ + "img/swiper_03.1cca5c88.jpg";